import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "react-bootstrap";

const DeleteComponent = ({ handleCancelDelete, open, toggleModel, handleConfirmDelete, question, title , acceptBtnText="Save"}) => {
    return (
        <Modal show={open} toggle={toggleModel} modalTransition={{ timeout: 300 }}>
            <ModalBody >
                <div className="modal-body text-center pt-5 m-2">
                    <div className="icon-box">
                        <i className="ico-times" role="img" aria-label="Cancel">x</i>
                    </div>
                    <h2>{title}</h2>
                    <p>{question}</p>
                </div>

                <div className="d-flex">
                    <button onClick={handleCancelDelete} className="btn btn-light  my-3 w-100">
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-dark  my-3 w-100" onClick={handleConfirmDelete}>
                        {acceptBtnText}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    );
};
DeleteComponent.defaultProps = {
    question: "Are you certain that you wish to delete this record?",
    title: "DELETE",
};
DeleteComponent.propTypes = {
    handleCancelDelete: PropTypes.func,
    handleConfirmDelete: PropTypes.func,
    question: PropTypes.string,
    title: PropTypes.string,
};

export default DeleteComponent;
